import React from "react";
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { rem } from "polished";
import { Tooltip as ReactTooltip } from "react-tooltip";

import {
  changeBottom,
  changeCurrentEvent,
  changeLeft,
  changeRight,
  changeTop,
  getDimensions,
  getLineAlignment,
  getSelectedVariation,
  getTileShape,
} from "../../../../../../lib/redux/slices/dimensions-slice";
import { useUpdateCart } from "../../../../../../hooks/use-update-cart";

const TileInputField = ({ variationImage, hasVertical }) => {
  const dispatch = useDispatch();

  const {
    top,
    left,
    right,
    bottom,
    tileShape,
    restrictions: { minHeight, maxHeight, minWidth, maxWidth, jointPosWidth },
  } = useSelector(getDimensions);

  const selectedVariation = useSelector(getSelectedVariation);
  const lineAlignment = useSelector(getLineAlignment);
  const currentShape = useSelector(getTileShape);

  const [tileInputValue, setTileInputValue] = React.useState({
    top: parseInt(top),
    left: parseInt(left),
    right: parseInt(right),
    bottom: parseInt(bottom),
  });

  const { updateCart } = useUpdateCart();

  React.useEffect(() => {
    if (currentShape) {
      setTileInputValue({
        top: parseInt(top),
        left: parseInt(left),
        right: parseInt(right),
        bottom: parseInt(bottom),
      });
    }
  }, [bottom, currentShape, left, right, top]);

  const isLeft = tileShape === "left";
  const isRight = tileShape === "right";
  const isSimple = tileShape === "simple";

  const setTop = (top) => {
    dispatch(changeCurrentEvent("input"));
    dispatch(changeTop(top));
  };
  const setLeft = (left) => {
    dispatch(changeCurrentEvent("input"));
    dispatch(changeLeft(left));
  };
  const setBottom = (bottom) => {
    dispatch(changeCurrentEvent("input"));
    dispatch(changeBottom(bottom));
  };
  const setRight = (right) => {
    dispatch(changeCurrentEvent("input"));
    dispatch(changeRight(right));
  };

  const verifyLimit = (e) => {
    const name = e.target.name;
    const value = parseInt(e.target.value) || 0;

    const limitValue = (min, max, val) => Math.min(Math.max(min, val), max);

    const limit = (minValue, maxValue) => {
      const limitedValue = limitValue(minValue, maxValue, value);
      setTileInputValue({
        ...tileInputValue,
        [name]: limitedValue,
      });
      return limitedValue;
    };

    switch (name) {
      case "top":
        const isSplit = lineAlignment === 'split' ? jointPosWidth : maxWidth;
        setTop(limit(minWidth, isSplit));
        break;

      case "left":
        const limitLeft = (isRight || !isLeft)
          ? limit(minHeight, maxHeight)
          : limit(minWidth, maxWidth);
        setLeft(limitLeft);
        break;

      case "right":
        const limitRight = (isRight || !isLeft)
          ? limit(minWidth, maxWidth)
          : limit(minHeight, maxHeight);
        setRight(limitRight);
        break;

      case "bottom":
        const isSplitBottom = lineAlignment === 'split' ? jointPosWidth : maxWidth
        const bottomLimit = tileInputValue.bottom >= (tileInputValue.top - minWidth) ? limit(minWidth, tileInputValue.top - minWidth) : limit(minWidth, isSplitBottom);
        const limitBottom = isSimple
          ? bottomLimit
          : limit(minHeight, maxHeight);
        setBottom(limitBottom);
        break;

      default:
        break;
    }

    updateCart((store) => ({
      ...store,
      dimensions: {
        ...store.dimensions,
        [name]: value,
      },
    }));
  };

  const handleChange = (e) => {
    let name = e.target.name;
    let value = parseInt(e.target.value);
    setTileInputValue({ ...tileInputValue, [name]: value });
  };

  console.log('xxxx', minHeight, maxHeight, minWidth, maxWidth)

  return (
    <TileInputFields className="builder-element">
      <div className="element">
        <h5>Egna mått</h5>

        <div className="measurement">
          <div className="left-block">
            <label className="left">
              <div data-tooltip-id="tooltip-left" className="tooltip">
                {isRight || isSimple ? "Djup" : "Längd"}
              </div>
              <ReactTooltip
                id="tooltip-left"
                place="top"
                content={`${(isRight || !isLeft) ? minHeight : minWidth} - ${
                  (isRight || !isLeft) ? maxHeight : maxWidth
                } mm`}
              />
              <input
                name="left"
                type="number"
                value={tileInputValue.left}
                min={(isRight || !isLeft) ? minHeight : minWidth}
                max={(isRight || !isLeft) ? maxHeight : maxWidth}
                step={5}
                onBlur={(e) => verifyLimit(e)}
                onChange={(e) => handleChange(e)}
              />
            </label>
          </div>
          <div className="top-bottom-block">
            <div className="top-block">
              <label className="top">
                <div data-tooltip-id="tooltip-top" className="tooltip">
                  Längd
                </div>
                <ReactTooltip
                  id="tooltip-top"
                  place="top"
                  content={`${minWidth} - ${lineAlignment === 'split' ? jointPosWidth : maxWidth} mm`}
                />
                <input
                  name="top"
                  type="number"
                  value={tileInputValue.top}
                  min={minWidth}
                  max={lineAlignment === 'split' ? jointPosWidth : maxWidth}
                  step={5}
                  onBlur={(e) => verifyLimit(e)}
                  onChange={(e) => handleChange(e)}
                />
              </label>
            </div>
            <div className="image">
              <img src={selectedVariation.image} alt="" width={80} />
            </div>

            <div className="bottom-block">
              {Boolean(hasVertical || lineAlignment !== "standard") && (
                <label className="bottom">
                  <div data-tooltip-id="tooltip-bottom" className="tooltip">
                    {/* Längd */}
                    {isSimple ? "Skarv pos" : "Djup"}
                  </div>
                  <ReactTooltip
                    id="tooltip-bottom"
                    place="top"
                    content={`${isSimple ? minWidth : minHeight} - ${isSimple ? lineAlignment === 'split' ? jointPosWidth : maxWidth : maxHeight} mm`}
                  />
                  <input
                    name="bottom"
                    type="number"
                    value={tileInputValue.bottom}
                    min={isSimple ? minWidth : minHeight}
                    max={isSimple ? lineAlignment === 'split' ? jointPosWidth : maxWidth : maxHeight}
                    step={5}
                    onBlur={(e) => verifyLimit(e)}
                    onChange={(e) => handleChange(e)}
                  />
                </label>
              )}
            </div>
          </div>
          <div className="right-block">
            {hasVertical && (
              <label className="right">
                <div data-tooltip-id="tooltip-right" className="tooltip">
                  {isRight ? "Längd" : "Djup"}
                </div>
                <ReactTooltip
                  id="tooltip-right"
                  place="top"
                  content={`${isRight ? minWidth : minHeight} - ${
                    isRight ? maxWidth : maxHeight
                  } mm`}
                />
                <input
                  name="right"
                  type="number"
                  value={tileInputValue.right}
                  min={isRight ? minWidth : minHeight}
                  max={isRight ? maxWidth : maxHeight}
                  step={5}
                  onBlur={(e) => verifyLimit(e)}
                  onChange={(e) => handleChange(e)}
                />
              </label>
            )}
          </div>
        </div>
      </div>
    </TileInputFields>
  );
};
export default TileInputField;

const TileInputFields = styled.div`
  ${({ theme }) => css`
    .element {
      h5 {
        margin-bottom: ${rem(15)};
        font-size: 14px;
        font-weight: bold;
      }

      .measurement {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .tooltip {
          border-bottom: 1px dotted ${theme.colors.primary};
          cursor: help;
          display: inline-block;
          margin-bottom: 10px;
          opacity: 1;
          position: static;

          &:hover {
            color: ${theme.colors.primary};
          }
        }

        .right-block,
        .top-bottom-block,
        .left-block {
          flex: 0 0 33.333%;
          max-width: 33.333%;

          input {
            width: 100%;
            border: 1px solid ${theme.colors.gray["400"]};
            min-height: 30px;
            padding: 0 5px;
          }
        }

        .image {
          padding: 20px 0;
        }
        .top-bottom-block {
          padding: 0 5px;
        }
        .right-block,
        .left-block {
          margin-top: -15px;
        }
        .left-block {
          padding-right: 10px;
        }
        .right-block {
          padding-left: 10px;
        }
      }
    }
  `}
`;
